<div class="w-12 flex-x flex-l flex-middle flex-justify-end b-b b-col-5"
     sizeClass="XL: height-100">
    <div class="w-12 flex flex-column flex-justify-center flex-middle p-t-10-m p-t-10-s search-content-block"
         sizeClass="MS: height-100">
        <!-- search -->
        <div class="p-t-6 p-b-6">
            <search searchId="header"
                    (focusChange)="onFocusChange($event)"></search>
        </div>
    </div>
</div>
